import { Link } from "react-router-dom"
import Header from "../../../components/forms/Header"
import { usePublicSiteBranding } from "../../../contexts/PublicSiteContext"

export default function DeleteAccountEmailSentPage() {
  const branding = usePublicSiteBranding()

  return (
    <section
      className={`flex pt-6 md:pt-none md:items-center md:pb-44 justify-center md:w-full ${branding.authPageMdGradientClass}`}
    >
      <div className="md:w-2/4 lg:max-w-xl md:p-5 md:shadow-xl md:rounded-xl bg-white">
        <Header heading="Check your email" paragraph="" linkName="" linkUrl="" />
        <p className="text-center text-sm text-gray-600 mt-5 px-2">
          If an account exists for the email you entered, we have sent a message with a link to
          confirm deletion of your {branding.productDisplayName} account. Your account will not be
          deleted until you open that email and confirm.
        </p>
        <p className="text-center text-sm text-gray-600 mt-4 px-2">
          The link expires after 24 hours. If you do not see the message, check your spam or junk
          folder.
        </p>
        <div className="flex justify-center pt-8">
          <Link to="/" className="text-black hover:text-primary font-medium">
            Return to home
          </Link>
        </div>
      </div>
    </section>
  )
}
